<div class="c__payment-labels">
  <div class="c__divided-values">
    <sd-icon name="icon-oney" [size]="iconSizeEnum.medium" />
  </div>

  @if (dividedData?.price) {
    <a (click)="onDividedClick()" class="is-full-area c__label is-caption">
      {{ dividedData?.paymentLabel }}
    </a>
  }
</div>
@if (dividedData?.paymentLabelExtended) {
  <div class="c__extended-label">
    <p class="is-medium is-uppercase is-text-center is-caption">
      {{ dividedData?.paymentLabelExtended }}
    </p>
  </div>
}
